import { MapPin, MessageCircle, Calendar } from "lucide-react";
import { socialLinks, palette } from "../style_palete";

export default function Contact() {
  return (
    <section id="contacto" className="py-20 "
    style={{ backgroundColor: palette.sky2 }}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        
        {/* Título */}
          <div className="max-w-2xl">
            <div className="mb-6">
              <h2 className="text-3xl md:text-4xl font-semibold text-[#0F1B2D] mb-3">
                Contacto & Turnos
              </h2>
              <div className="w-36 h-1.5 bg-[#2E8BC0] rounded-full"></div>
            </div>

            <p className="text-[#5E738A] text-lg mt-5">
              Escribinos por WhatsApp para coordinar tu consulta. También podés acercarte a nuestro centro.
            </p>
          </div>

        
        {/* Layout principal: info + mapa */}
        <div className="grid md:grid-cols-2 gap-10 items-start">
          
          {/* Columna izquierda: info de contacto + horarios + botón */}
          <div className="space-y-6">
            
            {/* Dirección + WhatsApp en 2 columnas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              
              {/* Card Dirección */}
              <div className="rounded-2xl border border-[#E1EBF5] bg-white/80 backdrop-blur p-4 shadow">
                <div className="flex items-center gap-4">
                  <div 
                    className="h-12 w-12 rounded-full flex items-center justify-center text-white shadow"
                    style={{ background: `linear-gradient(135deg, ${palette.primary}, ${palette.teal})` }}
                  >
                    <MapPin className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="font-semibold text-lg text-[#0F1B2D]">Dirección</p>
                    <p className="text-slate-600 mt-1">Carlos Casares 1220</p>
                    <p className="text-slate-600">Castelar, Buenos Aires</p>
                  </div>
                </div>
              </div>
              
              {/* Card WhatsApp */}
              <div className="rounded-2xl border border-slate-200 bg-white/70 p-5 shadow-sm hover:shadow-md transition">
                <div className="flex items-center gap-4">
                  <div className="h-12 w-12 rounded-full flex items-center justify-center bg-green-500 text-white shadow">
                    <MessageCircle className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="font-semibold text-lg text-[#0F1B2D]">WhatsApp</p>
                    <p className="text-slate-600 mt-1">+54 9 11 56601095</p>
                    <p className="text-sm text-green-600 font-medium">Turnos inmediatos</p>
                  </div>
                </div>
              </div>

            </div>

            {/* Horarios */}
            <div className="rounded-2xl border border-slate-200 bg-white/70 p-5 shadow-sm">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-3 text-[#0F1B2D]">
                <Calendar className="h-5 w-5" />
                Horarios de atención
              </h3>
              <div className="space-y-3 text-sm">
                <div className="flex justify-between items-center py-2 border-b border-slate-100">
                  <span className="font-medium text-[#0F1B2D]">Lunes, Miércoles y Viernes</span>
                  <span className="text-slate-600 bg-slate-50 px-3 py-1 rounded-full">
                    14:00 a 19:00 hs
                  </span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="font-medium text-[#0F1B2D]">Martes y jueves</span>
                  <span className="text-slate-600 bg-slate-50 px-3 py-1 rounded-full">
                    12:00 a 18:00 hs
                  </span>
                </div>
              </div>
            </div>

            {/* Botón de WhatsApp grande */}
            <a 
              href={socialLinks.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 rounded-2xl px-6 py-4 font-semibold text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all w-full justify-center mt-2"
              style={{ background: `linear-gradient(135deg, ${palette.primary}, ${palette.teal})` }}
            >
              <MessageCircle className="h-5 w-5" />
              Reservar turno por WhatsApp
            </a>
          </div>

          {/* Columna derecha: mapa */}
          <div className="rounded-2xl border border-white/60 bg-white/70 backdrop-blur p-4 shadow-lg">
            <iframe 
              title="Mapa Kalmares Castelar" 
              className="h-[400px] w-full rounded-xl" 
              loading="lazy" 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.507870792747!2d-58.644!3d-34.566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCastelar!5e0!3m2!1ses-419!2sar!4v1713377777"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
